import icons from '../../img/icons.svg';
import View from './View';
import { RESULTS_PER_PAGE } from '../config';

class PaginationView extends View {
  _parentElement = document.querySelector('.pagination');
  _errorMsg = 'Something wrong happened in the pagination part of the page';
  _msg = '';

  addHandlerPagination(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;
      const goToPage = btn.dataset.goToPage
      handler(+goToPage);
    });
  }

  _generateMarkup() {
    const data = this._data;
    const numPages = Math.ceil(data.results.length / RESULTS_PER_PAGE);
    const curPage = data.page;

    // If only 1 page
    if (curPage === 1 && numPages === curPage) {
      return '';
    }
    // If page is 1 and more pages
    if (curPage === 1 && numPages > 1) {
      return `
        <button data-go-to-page = "${curPage + 1}" class="btn--inline pagination__btn--next">
            <span>Page ${curPage + 1}</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
        </button>
        `;
    }
    // If last page
    if (curPage === numPages && numPages > 1) {
      return `
        <button data-go-to-page = "${curPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${curPage - 1}</span>
        </button>
        `;
    }

    // If between pages
    if (curPage > 1 && curPage < numPages) {
      return `
        <button data-go-to-page = "${curPage - 1}" class="btn--inline pagination__btn--prev">
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-left"></use>
                </svg>
                <span>Page ${curPage - 1}</span>
              </button>
              <button data-go-to-page = "${curPage + 1}" class="btn--inline pagination__btn--next">
                <span>Page ${curPage + 1}</span>
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-right"></use>
                </svg>
         </button>
        `;
    }
  }
}

export default new PaginationView();
